import { Stack, Typography, Chip, Link } from "@mui/material";
import React from "react";
import { GetMetadataByTagName } from "../../../Core/Utils/asset-object-utils";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";
import { LIB_PROJECT_VALUE_LABEL } from "../../Adam/adam-trailers";
import { Link as RouterLink } from "react-router";
import { routePaths } from "../../../Router/router";
import { gridDensitySelector, useGridApiContext, useGridSelector } from "@mui/x-data-grid-premium";

export interface TableCellAdamObjectInfosProps {
  asset: DbAssetObjectInfos;
}

const TableCellAdamObjectInfos: React.FC<TableCellAdamObjectInfosProps> = ({ asset }) => {
  const apiRef = useGridApiContext();
  const density = useGridSelector(apiRef, gridDensitySelector);

  if (!asset) return <></>;

  let isTrailer: boolean = GetMetadataByTagName(asset, "adamAssetType")?.value === "trailer";

  if (isTrailer) {
    let libProject = GetMetadataByTagName(asset, "rc_ba_lib_projet")?.value;
    let libCmd = GetMetadataByTagName(asset, "rc_ba_lib_commande")?.value;
    let title = GetMetadataByTagName(asset, "rc_ba_titres_emissions");

    return (
      <Stack gap={0.5} width="100%">
        <Link
          color="primary.text"
          underline="hover"
          component={RouterLink}
          to={`${routePaths.asset.path}/${asset.id}`}
          target="_blank"
          sx={(t) => ({ ...t.typography.body1, whiteSpace: density === "compact" ? "nowrap" : "break-spaces" })}
        >
          {`${GetMetadataByTagName(asset, "rc_ba_id")?.value} - ${title ? title.value : asset.name}`}
        </Link>

        {density !== "compact" && (
          <>
            <Typography variant="body2" color="text.tier">
              {GetMetadataByTagName(asset, "rc_ba_libelle")?.value ?? asset.name}
            </Typography>

            <Stack spacing={1} direction="row">
              <Chip
                label={LIB_PROJECT_VALUE_LABEL.find((x) => x.value === libProject)?.label ?? libProject}
                size="small"
                color="info"
              />
              {libCmd && <Chip label={libCmd} size="small" />}
              <Chip label={GetMetadataByTagName(asset, "rc_ba_lib_sous_classe")?.value} size="small" />
              <Chip label={GetMetadataByTagName(asset, "rc_ba_duree_prevu")?.value} size="small" />
            </Stack>
          </>
        )}
      </Stack>
    );
  } else {
    let mediaId = GetMetadataByTagName(asset, "rc_prg_media_id")?.value;

    return (
      <Stack gap={0.5}>
        <Link
          color="primary.text"
          underline="hover"
          component={RouterLink}
          to={`${routePaths.asset.path}/${asset.id}`}
          target="_blank"
          sx={(t) => ({ ...t.typography.body1, whiteSpace: density === "compact" ? "nowrap" : "break-spaces" })}
        >
          {`${GetMetadataByTagName(asset, "rc_prg_id")?.value} - ${
            GetMetadataByTagName(asset, "rc_prg_titre")?.value ?? asset.name
          }`}
        </Link>

        {density !== "compact" && (
          <>
            <Typography variant="body2" color="text.tier">
              {GetMetadataByTagName(asset, "rc_prg_sous_titre")?.value ?? asset.name}
            </Typography>

            {mediaId && (
              <Stack spacing={1} direction="row">
                <Chip label={GetMetadataByTagName(asset, "rc_prg_media_id")?.value} size="small" />
              </Stack>
            )}
          </>
        )}
      </Stack>
    );
  }
};

export default TableCellAdamObjectInfos;
